// extracted by mini-css-extract-plugin
export default {"logo":"EventManager_logo__D-nZe"};